import type { JobAssessmentFeedback } from "@repo/app-types/entities/jobAssessmentFeedback";
import type { JobDescriptionFeedback } from "@repo/app-types/entities/jobDescriptionFeedback";
import type { JobQuestionsFeedback } from "@repo/app-types/entities/jobQuestionsFeedback";
import { api } from "../redux.js";

const projectFeedbackApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Project feedback endpoints
    projectJobDescriptionFeedbackById: builder.query<
      JobDescriptionFeedback,
      string
    >({
      query: (id) =>
        `/projects/${encodeURIComponent(id)}/job-description-feedback`,
    }),
    projectJobAssessmentFeedbackById: builder.query<
      JobAssessmentFeedback,
      string
    >({
      query: (id) =>
        `/projects/${encodeURIComponent(id)}/job-assessment-feedback`,
    }),
    projectJobQuestionsFeedbackById: builder.query<
      JobQuestionsFeedback,
      string
    >({
      query: (id) =>
        `/projects/${encodeURIComponent(id)}/job-questions-feedback`,
    }),
  }),
});

export const {
  useProjectJobDescriptionFeedbackByIdQuery,
  useProjectJobAssessmentFeedbackByIdQuery,
  useProjectJobQuestionsFeedbackByIdQuery,
} = projectFeedbackApi;
